export enum LAYOUT {
  CAPTURE = 'capture',
  EMPTY = 'empty',
  PUBLIC = 'public',
  AUTH = 'auth',
  CLEAN = 'clean',
  DEFAULT = 'default',
}

export enum LAYOUT_WIDTH {
  FULL = 'full',
  WIDE = 'wide',
  DEFAULT = 'default',
}
